import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome} from '@fortawesome/free-solid-svg-icons';
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
class Valuation extends Component {
    render() {
        return (
            <div>
                <div aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"> <Link ><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                        <li class="breadcrumb-item active">Valuation </li>
                    </ol>
                </div>
                <section class="course-header bg-blue1" id="course-header">
                    <div class="row">
                        <div class="col-md-5 col-sm-12">
                            <h1>Valuation</h1>
                            <p>Providing an understanding of the fundamental approach to valuation, difference methodology and practical aspects.</p>
                            <br />
                            <br />
                            <div class="row">
                                <button class="pulse-button" type="button" data-toggle="modal" data-target="#myModalq" onclick="startvideo()"></button>
                                <p class="Watch-Intro">Watch Intro Video </p>
                            </div>
                            <br /> <br />
                            <div class="form-group">
                                <a href="#apply-now" class="btn btn-md enroll-btn" >Enroll Now </a>
                                <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                                    data-target="#myModal">Download
                                 brochure</button> <br /> <br />
                            </div>
                        </div>
                        <div class="col-md-2 col-sm-12"></div>
                        <div class="col-md-5 col-sm-12">
                            <p>Jointly Delivered by </p>
                            <ul>
                                <li><img alt="epn" width="" src="/assets/images/epn.svg" /></li>
                             &nbsp&nbsp&nbsp&nbsp  <li ><img alt="guru" width="100px" height="75px;" src="/assets/images/icons/guru&jana.jpg" /></li><br />
                            </ul>
                            <br />
                        </div>
                    </div>
                </section>
                <div class="course-main-contains def-z" id="Description"  >
                    <div class="card">
                        <div class="row contanint-display">
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">
                                <b>What's included : <br />
                                    <i class="fa fa-mobile" ></i> &nbsp;&nbsp;Mobile Support</b>
                            </div>
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">
                                <b><i class="fa fa-comments" ></i> &nbsp; Discussion Forum</b><br />
                                <b><i class="fa fa-certificate" ></i> &nbsp; Course Certificate</b>
                            </div>
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">
                                <b><i class="fa fa-question" ></i> &nbsp;&nbsp;&nbsp;Quiz</b><br />
                            </div>
                        </div>
                    </div>
                </div>
                <section class="def-z">
                    <div class="header" id="myHeader">
                        <ul>
                            <li><a href="#Description">Description</a></li>
                            <li><a href="#course-description">Eligibility</a></li>
                            <li><a href="#Syllabus">Syllabus</a></li>
                            <li><a href="#Outcomes">Learning Outcomes</a></li>
                            <li><a href="#Reviews">Learner Review </a></li>
                            <li><a href="#Instructor">About Instructor</a></li>
                            <li class="btn-header cs-dx"><a href="#apply-now">Enroll Now</a></li>
                        </ul>
                    </div>
                </section>
                <section class="course-description" id="course-description">
                    <br />
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Description</h3>
                            <p align="justify">In this 6 session course, you will get a practical hands-on experience on how to determine the financial health of a company and estimate future earnings and value of a company. Using some case studies and illustrations we will explain the various criteria that can help an organization take decisions about investing money.</p>
                            <br />
                        </div>
                    </div>
                    <h3 class="heading-tab">Who Should Enroll?</h3>
                    <div class="row">
                        <div class="col-sm-4">
                            <ul class="highlight-ul">
                                <li>Finance Professionals/Consultants</li>
                                <li>Securities Professionals</li>
                                <li>Financial/Business Analysts</li>
                            </ul>
                        </div>
                        <div class="col-sm-4">
                            <ul class="highlight-ul">
                                <li id="Syllabus">Banking/Insurance Professionals</li>
                                <li>Valuers</li>
                                <li>CMD/CEO/CFO/Director/GM/Finance Heads</li>
                            </ul>
                        </div>
                        <div class="col-sm-4">
                            <ul class="highlight-ul">
                                <li>Engineers</li>
                                <li>Academicians</li>
                            </ul>
                        </div>
                    </div>
                </section>
                <section class="course-syllabus" id="course-syllabus">
                    <div class="row" >
                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10" >
                            <h3> Syllabus </h3>
                            <br />
                            <div class="syl-bg">
                                <div id="de_syllabus">
                                    <div class="panel-group">
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                                                href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                            }   <a><i class="indicator fa fa-minus"></i> Section 1 </a>
                                                </h6>
                                            </div>
                                            <div id="de_syllabus1" class="collapse show" aria-labelledby="de_heading1"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Introduction</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading2" data-toggle="collapse"
                                                href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                            }  <a><i class="indicator fa fa-minus"></i> Section 2</a>
                                                </h6>
                                            </div>

                                            <div id="de_syllabus2" class="collapse show" aria-labelledby="de_heading2"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Financial Modelling and Projections</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading3" data-toggle="collapse"
                                                href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                            }  <a><i class="indicator fa fa-minus"></i>Section 3</a>
                                                </h6>
                                            </div>

                                            <div id="de_syllabus3" class="collapse show" aria-labelledby="de_heading3"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Regulatory Scenario in India</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading4" data-toggle="collapse"
                                                href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                            }   <a><i class="indicator fa fa-minus"></i>Section 4</a>
                                                </h6>
                                            </div>

                                            <div id="de_syllabus4" class="collapse show" aria-labelledby="de_heading4"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>DCF Valuation - Volume 2</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading5" data-toggle="collapse"
                                                href="#de_syllabus5" aria-expanded="true" aria-controls="de_syllabus5">
                                                <h6 class="panel-title">{// eslint-disable-next-line
                                            }  <a><i class="indicator fa fa-minus"></i>Section 5</a>
                                                </h6>
                                            </div>

                                            <div id="de_syllabus5" class="collapse show" aria-labelledby="de_heading5"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>DCF Valuation - Volume 3</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading6" data-toggle="collapse"
                                                href="#de_syllabus6" aria-expanded="true" aria-controls="de_syllabus6">
                                                <h6 class="panel-title" id="Outcomes">{// eslint-disable-next-line
                                            } <a><i class="indicator fa fa-minus"></i>Section 6</a>
                                                </h6>
                                            </div>

                                            <div id="de_syllabus6" class="collapse show" aria-labelledby="de_heading6"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>DCF Valuation - Volume 4</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="course-learning-outcome bg-secondary " id="course-learning-outcome">
                    <div class="row">
                        <div class="col-sm-6">
                            <h3>Learning Outcomes</h3>
                            <ul class="lo-ul">
                                <li>Develop proficiency in valuation, analyses and application of valuation tools and techniques</li>
                                <li>Develop expertise towards applying valuation techniques</li>
                                <li>Develop capabilities to offer advisory/consultancy services in the area of valuation</li>
                                <li>Understand various Corporate and Tax laws required to be considered while carrying out valuation assignments for different purposes and under different contexts.</li>
                            </ul>
                            <br />
                            <h3>Assessment</h3>
                            <div class="table-responsive course-batch-schedule">
                                <div class="card">
                                    <table class="table">
                                        <thead>
                                            <tr class="text-center">
                                                <th >Type</th>
                                                <th >Weightage %</th>
                                            </tr>
                                        </thead>
                                        <tbody class="content-size">
                                            <tr>
                                                <td >Content</td>
                                                <td id="Reviews">100%</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <img alt="certificate1" src="/assets/images/icons/certificate1.png" />
                        </div>
                    </div>
                    <br /><br />
                </section>
                <Aboutuslearners />
                <Aluminicompany />
                <section class="courses-feesm">
                    <section class="course-fees" id="course-fees">
                        <div class="row box-sh" >
                            <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                            </div>
                            <div class="vertical-line-fee"> </div>
                            <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                                <div class="row">
                                    <div class="col-sm-10"> <br /><br />
                                        <h5>Features</h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 col-sm-12">
                                        <ul class="highlight-ss" >
                                            <li> Guru and Jana as the knowledge partner</li>
                                            <li> Mentorship by industry specialists</li>
                                            <li> Seamless EMI options</li>
                                            <li> Industry-oriented curriculum</li>
                                        </ul>
                                    </div>
                                    <p>{// eslint-disable-next-line
                                    }<marquee onmouseover="this.stop();" onmouseout="this.start();" class="marquee-enroll" >"If a group of four or more participants enroll with us, a concession of 10% will be awarded to each one of them. For more details Contact us."<a href="tel://8956167195 " > &nbsp;&nbsp;<i class="fa fa-mobile" aria-hidden="true"></i> +91 8956167195</a></marquee>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
                <Whyedu />
                <section class="course-about-instructor bg-secondary " id="course-about-instructor" >
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>About the Instructor</h3>
                            <br />
                            <div class="about-ist">
                                <div class="card pd-abt-ist">
                                    <div class="social-instructor">
                                        <img onerror="this.onerror=null;this.src='https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/default_avatar.jpg';" alt="" src="https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/29_chinmaya-242x300.jpg" />
                                    </div>
                                    <div class="inst-details">
                                        <h3>Chinmaya A M</h3>
                                        <p>10 Years Of Experience</p>
                                        <br />
                                        <h4>Guru and Jana</h4>
                                        <p align="justify">Chinmaya is a partner at Guru and Jana since 2016. A Chartered Accountant with a degree in Commerce, he has an expertise in Deal Advisory, Diligence, Valuation, Structuring &amp; FEMA assistance and heads Consulting Practice at the firm. His professional focus is in Consulting Space, mainly into Investment Advisory, M&amp;As, Group Restructuring, Inbound and Outbound advisory. He is actively engaged in Business Development and Brand initiatives of the firm. He has been invited as a speaker at many professional forums, including ICAI and ICSI and served as an academic instructor to CA and CS aspirants.</p>
                                        <br />
                                        <ul class="course-about-ul">
                                            <li>{// eslint-disable-next-line
                                            } <a href="#" >
                                                    <i class="fa fa-facebook" target="_blank"></i>
                                                </a>
                                            </li>
                                            <li>{// eslint-disable-next-line
                                            }<a href="#"  >
                                                    <i class="fa fa-linkedin" target="_blank"></i>
                                                </a>
                                            </li>
                                            <li>{// eslint-disable-next-line
                                            }<a href="#" > <i class="fa fa-twitter" target="_blank"></i>
                                                </a>
                                            </li>
                                            <li>{// eslint-disable-next-line
                                            }<a href="#"  ><i class="fa fa-instagram" target="_blank"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default Valuation;